export const TEST_ID = 'stateComplianceModalSignature';
